// Padronização de telefone, CPF, CNPJ e CEP.
// No banco vai só dígito (String); a máscara é aplicada pelo sistema na tela, nunca digitada pelo usuário.
//
// mask*   -> progressiva, usada no formulário enquanto o usuário digita
// format* -> exibição (listas, documento da OS, PDF); se o valor antigo não tiver a quantidade certa de dígitos, devolve como está

export const onlyDigits = (value) => String(value ?? '').replace(/\D/g, '')

// ── normalizadores (o que é guardado) ─────────────────────────────────────────

// 0800, 0300, 0500, 0900 (ligação gratuita / serviços)
const isServiceNumber = (d) => /^0[3589]00/.test(d)

// sem zero de tronco antes do DDD (067... -> 67...), no máximo 11 dígitos
export function normalizePhoneDigits(value) {
    let d = onlyDigits(value)
    if (!isServiceNumber(d)) d = d.replace(/^0+/, '')
    return d.slice(0, 11)
}
export const normalizeCPFDigits = (value) => onlyDigits(value).slice(0, 11)
export const normalizeCNPJDigits = (value) => onlyDigits(value).slice(0, 14)
export const normalizeCEPDigits = (value) => onlyDigits(value).slice(0, 8)

// ── máscaras progressivas (formulário) ────────────────────────────────────────

// (67) 3333-4444 (fixo), (67) 99999-9999 (celular) ou 0800 123 4567
export function maskPhone(value) {
    const d = normalizePhoneDigits(value)
    if (!d) return ''
    if (isServiceNumber(d)) {
        if (d.length <= 4) return d
        if (d.length <= 7) return `${d.slice(0, 4)} ${d.slice(4)}`
        return `${d.slice(0, 4)} ${d.slice(4, 7)} ${d.slice(7)}`
    }
    if (d.length <= 2) return `(${d}`
    if (d.length <= 6) return `(${d.slice(0, 2)}) ${d.slice(2)}`
    if (d.length <= 10) return `(${d.slice(0, 2)}) ${d.slice(2, 6)}-${d.slice(6)}`
    return `(${d.slice(0, 2)}) ${d.slice(2, 7)}-${d.slice(7)}`
}

// 000.000.000-00
export function maskCPF(value) {
    const d = normalizeCPFDigits(value)
    if (d.length <= 3) return d
    if (d.length <= 6) return `${d.slice(0, 3)}.${d.slice(3)}`
    if (d.length <= 9) return `${d.slice(0, 3)}.${d.slice(3, 6)}.${d.slice(6)}`
    return `${d.slice(0, 3)}.${d.slice(3, 6)}.${d.slice(6, 9)}-${d.slice(9)}`
}

// 00.000.000/0000-00
export function maskCNPJ(value) {
    const d = normalizeCNPJDigits(value)
    if (d.length <= 2) return d
    if (d.length <= 5) return `${d.slice(0, 2)}.${d.slice(2)}`
    if (d.length <= 8) return `${d.slice(0, 2)}.${d.slice(2, 5)}.${d.slice(5)}`
    if (d.length <= 12) return `${d.slice(0, 2)}.${d.slice(2, 5)}.${d.slice(5, 8)}/${d.slice(8)}`
    return `${d.slice(0, 2)}.${d.slice(2, 5)}.${d.slice(5, 8)}/${d.slice(8, 12)}-${d.slice(12)}`
}

// 00000-000
export function maskCEP(value) {
    const d = normalizeCEPDigits(value)
    if (d.length <= 5) return d
    return `${d.slice(0, 5)}-${d.slice(5)}`
}

// ── exibição (telas e PDF) ────────────────────────────────────────────────────

const raw = (value) => (value == null ? '' : String(value))

export function formatPhone(value) {
    const n = normalizePhoneDigits(value).length
    return n === 10 || n === 11 ? maskPhone(value) : raw(value)
}
export const formatCPF = (value) => (onlyDigits(value).length === 11 ? maskCPF(value) : raw(value))
export const formatCNPJ = (value) => (onlyDigits(value).length === 14 ? maskCNPJ(value) : raw(value))
export const formatCEP = (value) => (onlyDigits(value).length === 8 ? maskCEP(value) : raw(value))
